import React, { useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { StyledIntroCardsQuestion as S } from 'pages/questions/shared/introCardsQuestion.styles'

import { SvgImage } from 'components/SvgImage'
import {
  TERMS_LINKS_GROUP_VARIANT,
  TermsLinksGroup,
} from 'components/TermsLinksGroup'

import { useActiveLanguage } from 'hooks/useActiveLanguage'
import { useDelayedContinue } from 'hooks/useDelayedContinue'
import { useDynamicTextsFromUrl } from 'hooks/useDynamicTextsFromUrl'
import { useNextStep } from 'hooks/useNextStep'

import { TPageProps } from 'models/common.model'

import chevronRightIcon from 'assets/images/sprite/chevron-right.svg'

import { CustomPageId } from 'page-constants'
import { Language, OptionType } from 'root-constants'

import { WOMAN_MAN_GENDER_OPTIONS } from '../../shared/constants'

export const AyahGenderV2: React.FC<TPageProps> = ({
  pageId,
  nextPagePath,
  isFirstPage,
}) => {
  const { t } = useTranslation()
  const { firstPageTitle, firstPageSubtitle } = useDynamicTextsFromUrl()
  const { isAnswersDisabled, handleChange, setIsAnswersDisabled } =
    useDelayedContinue()

  const { isIdLanguage } = useActiveLanguage()

  const [answer, setAnswer] = useState<string>('')

  const handleContinue = useNextStep({
    pageId: CustomPageId.GENDER,
    question:
      firstPageTitle ||
      t('onboarding.selectGenderAyah.title', { lng: Language.EN }),
    nextPagePath,
    isFirstPage,
  })

  const handleAnswerChange = (value: string) => {
    handleChange(value, handleContinue)
    setIsAnswersDisabled(true)
    setAnswer(value)
  }

  return (
    <S.Container>
      <S.Title>
        {firstPageTitle || t('onboarding.selectGenderAyah.title')}
      </S.Title>
      <S.QuizLabel>{t('onboarding.ayahGender.quizLabel')}</S.QuizLabel>
      <S.Subtitle>
        {firstPageSubtitle || (
          <Trans i18nKey="onboarding.ayahGenderV2.subtitle" />
        )}
      </S.Subtitle>

      <S.Question>{t('onboarding.ayahGenderV2.genderQuestion')}</S.Question>

      <S.Options>
        {WOMAN_MAN_GENDER_OPTIONS.map(({ value, text }) => (
          <S.Option
            key={value}
            name={pageId}
            value={value}
            type={OptionType.RADIO}
            checked={answer === value}
            disabled={isAnswersDisabled}
            onChange={handleAnswerChange}
            withoutMargin
            $isSmallText={isIdLanguage}
          >
            {t(text)}
            <S.ArrowCircle $isLight={answer === value}>
              <SvgImage svg={chevronRightIcon} width={20} />
            </S.ArrowCircle>
          </S.Option>
        ))}
      </S.Options>

      <S.Terms>
        <TermsLinksGroup
          titleKey="commonComponents.termsGenderTitle"
          variant={TERMS_LINKS_GROUP_VARIANT.DARK}
        />

        <S.TermsNote>{t('commonComponents.termsNote')}</S.TermsNote>
      </S.Terms>
    </S.Container>
  )
}
